import React, { Component } from 'react';
import Text from '@dbk/ui-text';
import  Select  from '@dbk/ui-select';
import Button from '@dbk/ui-buttons';
import { createContainer } from '@dbk-legacy/muster/react';
import { LoadingCircle } from '../../components/common/loading';



class InvestmentFilter extends Component {
    constructor(props){
        super(props);
        this.state = {
            modal: true,
            CONTENT: [],
            CONTENT_ACTION: [],
        }
    }

    componentDidMount(){
      this.props.getAssetClass();
  }


    convertStringArrayToObjectArray = values => {
      return values && values.length ? values.map(e => ({ 
        label: e+'',
        value: e+'',
      })) : []
    }
   

  
    errorHandler = async () => {
      this.props.onErrorClosed();
    }
    
    applyClicked= ()=>{
      this.props.filterApplyClick()
    }


    render() {
      const {
        selectedAssets,
        selectedAction,
        handleOnChangeAsset,
        handleOnChangeAction,
        totalCount,
        clearClicked,
        investmentFilter: {assetContent, investmentFilterError},
        i18n : { messages}

      }= this.props;
      
      if (!assetContent) {
        if(investmentFilterError && investmentFilterError.status.toUpperCase() === "ERROR"){
         this.errorHandler();
         return null;
        }
        return (
          <div>
            <LoadingCircle />
          </div>
        );
        }
        this.state.CONTENT =  this.convertStringArrayToObjectArray(assetContent.assets);
        this.state.CONTENT_ACTION =  this.convertStringArrayToObjectArray(assetContent.actions);
      
      return (
          <div className="filter-container row">
                <div className="asset-title">
                  <Text>{messages['app.investment.asset.title']}</Text>
                </div>
                <div>
                <Select
                  fullWidth
                  size="large"
                  defaultLabel={<Text>{messages['app.investment.default.assetMessage']}</Text>}
                  onChange={handleOnChangeAsset}
                  options = {this.state.CONTENT}
                  selectedItems={selectedAssets}
                />
                </div>  
           
            <div className="action-title">
              <Text >{messages['app.investment.action.title']}</Text>
            </div>
                  
            <Select
              fullWidth
              size="large"
              defaultLabel={<Text >{messages['app.investment.default.actionMessage']} </Text>}
              onChange={handleOnChangeAction}
              options={this.state.CONTENT_ACTION}
              selectedItems={selectedAction}
            />
              
            <div className="button-container">
                <Button className="clear-button" size="large" tertiary onPress={clearClicked} disabled = {totalCount === 0}>
                {messages['app.investment.clear.button']}
                </Button>
                <Button className="apply-button" size="large" primary onPress={this.applyClicked} disabled = {totalCount === 0}>
                 {messages['app.investment.apply.button']}
                </Button>
            </div> 
          </div> 
        
       
      );
  }

}

export default createContainer({
  $queries: {
    getAssetClass : {$call: 'investmentFilter.getAssetClass'},
    investmentFilter: {
      assetContent: true,
      investmentFilterError: true,
     
    },
    clearInvestmentData : {
      $set: 'ui.investmentData'
    },
    setErrorOccured: { $set: 'investmentFilter.APIError'},
    clearFilterError: { $set: 'investmentFilter.investmentFilterError'},
    changePage: { $call: 'ui.history.push' },
    goBack:{ $call: 'ui.history.goBack'},
    changeFromFilterPage : {$set:' investment.fromFilterPageApply'},
    setAssetsActions : {$set:'investment.getSelectedAssetsActions'},
    i18n : {
      messages:true
    },
    
},
  })(InvestmentFilter);